// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay-module--overlay--2NL7M","overlayIsVisible":"overlay-module--overlayIsVisible--2Nf8_"};